import { Loader } from "@braintrust/braintrust-ui-components";
import FullPageLayout from "@js/layouts/full-page";

import { useCanUserCreateInvoice } from "../../hooks/can-user-create-invoice";

import styles from "./style.module.scss";

type InvoicePageWrapperProps = {
  children: React.ReactNode;
  pageTitle: string;
};

export const InvoicePageLayout = ({
  children,
  pageTitle,
}: InvoicePageWrapperProps) => {
  const { isLoadingFinished } = useCanUserCreateInvoice();

  if (!isLoadingFinished) return <Loader centered />;

  return (
    <FullPageLayout
      pageTitle={pageTitle}
      showLogo={false}
      back
      closeURL="/talent/invoices/"
      className={styles.invoicePageLayout}
    >
      {children}
    </FullPageLayout>
  );
};
